export default __webpack_public_path__ + "static/media/product-19.ee99d6b3.jpg";